import { FC } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

import { PurchaseOrderLookup } from '../model';
import { formatQty } from '../receivingStatus';

interface ConfirmReceiveModalProps {
  open: boolean;
  purchaseOrder: PurchaseOrderLookup;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
}

// Flagged wins over the over-ordered sentence: a complete PO is the fact the receiver has to see,
// even when this count would also pass the ordered quantity.
const confirmMessage = (purchaseOrder: PurchaseOrderLookup, count: number): string => {
  const received = formatQty(purchaseOrder.received_quantity);
  const ordered = formatQty(purchaseOrder.ordered_quantity);
  const next = formatQty(Number(purchaseOrder.received_quantity) + count);
  const added = `${received} + ${formatQty(count)} = ${next}`;

  if (purchaseOrder.fully_received) {
    // Match the banner: ordered 0 / flagged with count 0 is "count not tracked", not "0 received".
    const receivedLabel = Number(purchaseOrder.received_quantity) === 0 ? 'count not tracked' : `${received} received`;
    return `This PO is already fully received (${receivedLabel}). With this receipt it would be ${added}. Receive anyway?`;
  }

  return `PO ${purchaseOrder.po_no} has already received ${received} of ${ordered}. With this receipt it would be ${added}, more than the ${ordered} ordered. Receive anyway?`;
};

const ConfirmReceiveModal: FC<ConfirmReceiveModalProps> = ({ open, purchaseOrder, count, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm" aria-labelledby="confirm-receive-message">
    <DialogContent>
      <DialogContentText id="confirm-receive-message">{confirmMessage(purchaseOrder, count)}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onConfirm}>
        Receive anyway
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmReceiveModal;
